module.exports = __webpack_public_path__ + "assets/images/BSD20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BSD20.png
// module id = 1317
// module chunks = 1